import AdminAffiliates from "../../Admin/AdminAffiliates/AdminAffiliates";
export default function Teams() {
  return <AdminAffiliates />;
}
